<template>
  <div class="offer-wrapper">
    <div class="shadow"></div>
    <div >
      <h5 class="h5-small pointer" @click="showDetails()">
        {{ this.reward.name }}
      </h5>
    </div>
    <div>
      <p class="description" v-html="this.reward.description.substring(0,50)"></p>
    </div>
    <div v-if="this.editable">
      <a @click="uploadRewardVouchers()" class="upload">
        <img src="@/assets/images/cms-mkt/upload.svg" />
      </a>
      <a @click="editRewardDetails()" class="edit">
        <img src="@/assets/images/cms-mkt/edit.svg" />
      </a>
      <a @click="approveReward()" class="approve" v-if="isUserAdmin(user)">
        <img src="@/assets/images/cms-mkt/check.svg" />
      </a>
      <a @click="deleteReward()" class="delete">
        <img src="@/assets/images/cms-mkt/delete.svg" />
      </a>
    </div>
<!-- <br/> -->
    <!-- <div>
      {{ this.reward.name }}
      <img class="personimg" :src="getImagePath() + 'users/' + user.id + '.png'"
        @error="($event.target.src = require('@/assets/images/cms-mkt/offer_0.svg'))" />
    </div> -->
  </div>
</template>

<script>

export default {
  name: "RewardCase",
  components: {},

  props: {
    editable: Boolean,
    user: Object,
    reward: Object,
    image: String,
  },
  data() {
    return {
      // rewardData: null,
    };
  },
  methods: {
    showDetails() {
      this.$emit("showdetails", this.reward);
    },
    uploadRewardVouchers() {
      this.$emit("upload", this.reward);
    },
    editRewardDetails() {
      this.$emit("edit", this.reward);
    }, 
    deleteReward() {
      this.$emit("delete", this.reward);
    },
    approveReward() {
      this.$emit("approve", this.reward);
    }
  }, 
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
